// alterado - revisado

import React from 'react'

import {
    ListRadioGroup,
} from '../../business-components/RadioGroup/RadioGroup'

import formatoReportList from '../List/formatoReportList'

export const FormatoReportRadioGroup = props => {
    return (
        <ListRadioGroup
            list={formatoReportList}
            {...props}
        />
    )
}